import { Pipe, PipeTransform } from "@angular/core";
import { CRM_EXPORT_DISABLED_MESSAGES } from "src/app/shared/constants/crm-export.constants";

@Pipe({
    name: 'crmExportDisabledTooltipPipe',
    standalone: false
})
export class CrmExportDisabledTooltipPipe implements PipeTransform {

    transform(params: { isOpsAdminNoCrmAdmin: boolean; isNonOpsNonCrmAdmin: boolean; disabled: boolean }): string {
        const { isOpsAdminNoCrmAdmin, isNonOpsNonCrmAdmin, disabled } = params;

        if (isOpsAdminNoCrmAdmin && !disabled) {
            return CRM_EXPORT_DISABLED_MESSAGES.OPS_ADMIN_NO_CRM_ADMIN;
        }

        if (isNonOpsNonCrmAdmin && !disabled) {
            return CRM_EXPORT_DISABLED_MESSAGES.NON_OPS_NON_CRM_ADMIN;
        }

        if (disabled) {
            return CRM_EXPORT_DISABLED_MESSAGES.GENERIC_DISABLED;
        }

        return '';
    }

}
